import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9002dc94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-endpoint-header hd-container" }
const _hoisted_2 = { class: "hd-endpoint-header__left" }
const _hoisted_3 = { class: "hd-endpoint-header__right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.arrowNavPath)
        ? (_openBlock(), _createBlock(_component_base_image_svg, {
            key: 0,
            class: "hd-endpoint-header__back-button",
            source: require('!html-loader!@/ui/assets/icons/chevron-left.svg'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo(_ctx.arrowNavPath)))
          }, null, 8, ["source"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "left-side", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "right-side", {}, undefined, true)
    ])
  ]))
}